import { render, staticRenderFns } from "./ResponsibleRadioInput.vue?vue&type=template&id=f6c04170"
import script from "./ResponsibleRadioInput.vue?vue&type=script&lang=js"
export * from "./ResponsibleRadioInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports